export enum ChannelDeverbIntensity {
	Low = 'LOW',
	Medium = 'MEDIUM',
	High = 'HIGH'
}
